import { createContext, useContext, type ChangeEvent, type RefObject } from 'react'

import type { Item, Keyboard, OrderValues, PartnersListProps } from '../types'

interface PartnerSearchContextProps extends Omit<PartnersListProps, 'items'> {
  toggleExpansion: () => void
  handleKeyPressDown: (event: React.KeyboardEvent) => void
  handleOptionChange: (event: Keyboard) => void
  handleSearchInput: (event: ChangeEvent<HTMLInputElement>) => void
  divRef: RefObject<HTMLDivElement>
  sortedPartners: Item[]
  shouldEnableNotifier: boolean
  checkedValue: OrderValues
  expanded: boolean
  inputSearchPartner: string
}

export const PartnerSearchContext = createContext<PartnerSearchContextProps>(
  {} as PartnerSearchContextProps,
)

export const usePartnerSearch = () => useContext(PartnerSearchContext)
